export function downloadFileFromStringData(fileName, data) {
    download(fileName, packageFile(data))
}

export function download(fileName, content) {
    if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(content, fileName)
    } else {
        // Chrome
        const element = document.createElement('a')
        const url = window.URL.createObjectURL(content)
        element.setAttribute('href', url)
        element.setAttribute('download', fileName)
        element.style.display = 'none'
        document.body.appendChild(element)
        element.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(element)
    }
}

export function packageFile(data) {
    return new Blob(['\ufeff', data], { // eslint-disable-line no-undef
        type: window.navigator.msSaveOrOpenBlob ? this.getMimeType() : 'octet/stream'
    })
}



// WEBPACK FOOTER //
// src/utils/download.js